import React, { useState } from 'react';
import { Button, Flex, Icon, Text, GridItem, Link, Grid } from '@spothero/ui';
import IconCheckmarkShieldFilled from '@spothero/icons/checkmark-shield-filled';
const ParkedCarProtectionDetails = ({ carProtectionAddOn, onTrackedClick, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleOpen = () => setIsOpen(prev => !prev);
    const { context: { faqLink, claimLink }, } = carProtectionAddOn;
    const handleClick = clickTarget => {
        onTrackedClick({ clickTarget, isReservationChange: false });
    };
    const handleModalToggle = () => {
        toggleOpen();
        let clickTarget;
        if (isOpen) {
            clickTarget = 'Parked Car Protection Less';
        }
        else {
            clickTarget = 'Parked Car Protection More';
        }
        handleClick(clickTarget);
    };
    return (<Grid borderBottomWidth="1px" borderColor="gray.100" padding={4} flexDirection="column" columnGap={2} gap={0} gridTemplateColumns="24px 1fr">
            <Icon as={IconCheckmarkShieldFilled} width={6} height="auto" color="green"/>
            <Flex alignItems="center" justifyContent="space-between">
                <Text lineHeight={1.4} color="green">
                    Parked Car Protection
                </Text>

                <Button fontFamily="body" variant="tertiary" onClick={handleModalToggle} sx={{
            '@media print': {
                display: 'none',
            },
        }}>
                    {isOpen ? 'Less' : 'More'}
                </Button>
            </Flex>

            <GridItem colStart="2" colSpan="1" transition="all 250ms ease-in-out" maxHeight={isOpen ? 80 : 0} paddingTop={isOpen ? 2 : 0} overflow={isOpen ? 'auto' : 'hidden'}>
                <Text>
                    Provided by our partner Park &rsquo;N&rsquo; Protect.
                </Text>
                <Text>
                    Check out our{' '}
                    <Link href={faqLink} onClick={() => handleClick('Parked Car Protection FAQ')} target="_blank" rel="noopener noreferrer">
                        FAQ
                    </Link>{' '}
                    or{' '}
                    <Link href={claimLink} onClick={() => handleClick('Parked Car Protection File A Claim')} target="_blank" rel="noopener noreferrer">
                        file a claim
                    </Link>
                    .{' '}
                </Text>
            </GridItem>
        </Grid>);
};
export default ParkedCarProtectionDetails;
